import i18next from '~/utils/i18n';

const notification = () => ({
    ADD_WORD_SUCCESS: i18next.t('Lookup.add_word_success'),
});

export default notification;
